// Sezonske cijene po apartmanu (po mjesecima / periodima)
export const PRICING_BY_SLUG = {
  "apartment-1": [
    { start: "01-01", end: "29-05", base: 60, extra: 10 }, // 3. i 4. osoba +10€
    { start: "30-05", end: "26-06", base: 80, extra: 10 },
    { start: "27-06", end: "24-07", base: 110, extra: 10 },
    { start: "25-07", end: "30-08", base: 140, extra: 10 },
    { start: "31-08", end: "06-09", base: 110, extra: 10 },
    { start: "07-09", end: "30-09", base: 80, extra: 10 },
    { start: "01-10", end: "31-12", base: 60, extra: 10 },
  ],

  "apartment-2": [
    { start: "01-01", end: "29-05", base: 60, extra: 10 }, // 3. i 4. osoba +10€
    { start: "30-05", end: "26-06", base: 80, extra: 10 },
    { start: "27-06", end: "24-07", base: 110, extra: 10 },
    { start: "25-07", end: "30-08", base: 140, extra: 10 },
    { start: "31-08", end: "06-09", base: 110, extra: 10 },
    { start: "07-09", end: "30-09", base: 80, extra: 10 },
    { start: "01-10", end: "31-12", base: 60, extra: 10 },
  ],

  "room-1": [
    { start: "01-01", end: "29-05", base: 50, extra: 0 },
    { start: "30-05", end: "26-06", base: 60, extra: 0 },
    { start: "27-06", end: "24-07", base: 75, extra: 0 },
    { start: "25-07", end: "30-08", base: 90, extra: 0 },
    { start: "31-08", end: "06-09", base: 75, extra: 0 },
    { start: "07-09", end: "30-09", base: 60, extra: 0 },
    { start: "01-10", end: "31-12", base: 50, extra: 0 },
  ],

  "room-2": [
    { start: "01-01", end: "29-05", base: 50, extra: 0 },
    { start: "30-05", end: "26-06", base: 60, extra: 0 },
    { start: "27-06", end: "24-07", base: 75, extra: 0 },
    { start: "25-07", end: "30-08", base: 90, extra: 0 },
    { start: "31-08", end: "06-09", base: 75, extra: 0 },
    { start: "07-09", end: "30-09", base: 60, extra: 0 },
    { start: "01-10", end: "31-12", base: 50, extra: 0 },
  ],
};
const toKey = (ddmm) => {
  const [d, m] = String(ddmm).split("-").map(Number);
  return (m || 0) * 100 + (d || 0);
};

export function getPriceForDate(seasons, date = new Date(), guests = 2) {
  if (!seasons?.length) return null;

  const todayKey = (date.getMonth() + 1) * 100 + date.getDate();

  const found = seasons.find((s) => {
    const startKey = toKey(s.start);
    const endKey = toKey(s.end);

    if (endKey < startKey) return todayKey >= startKey || todayKey <= endKey;
    return todayKey >= startKey && todayKey <= endKey;
  });

  if (!found) return null;

  const extraGuests = Math.max(0, (guests ?? 2) - 2);
  return (found.base ?? found.price ?? 0) + extraGuests * (found.extra || 0);
}

export function buildSeasonalPricesByMonth(seasons) {
  const out = {};
  const daysInMonth = (m) => new Date(2024, m, 0).getDate();

  const addRangeToMonth = (month, start, end, s) => {
    if (!out[month]) out[month] = [];
    out[month].push({
      start,
      end,
      base: s.base ?? s.price ?? 0,
      extra: s.extra ?? 0,
    });
  };

  (seasons || []).forEach((s) => {
    const [sDay, sMonth] = s.start.split("-").map(Number);
    const [eDay, eMonth] = s.end.split("-").map(Number);

    const wraps = eMonth < sMonth;

    if (!wraps) {
      // normal: startMonth .. endMonth
      for (let month = sMonth; month <= eMonth; month++) {
        const start = month === sMonth ? sDay : 1;
        const end = month === eMonth ? eDay : daysInMonth(month);
        addRangeToMonth(month, start, end, s);
      }
    } else {
      // wrap: startMonth..12 AND 1..endMonth
      for (let month = sMonth; month <= 12; month++) {
        const start = month === sMonth ? sDay : 1;
        const end = daysInMonth(month);
        addRangeToMonth(month, start, end, s);
      }
      for (let month = 1; month <= eMonth; month++) {
        const start = 1;
        const end = month === eMonth ? eDay : daysInMonth(month);
        addRangeToMonth(month, start, end, s);
      }
    }
  });

  Object.keys(out).forEach((m) => out[m].sort((a, b) => a.start - b.start));
  return out;
}
export function getFromPrice(seasons, guests = 2) {
  if (!seasons?.length) return null;

  const extraGuests = Math.max(0, (guests ?? 2) - 2);

  return Math.min(
    ...seasons.map((s) => {
      const base = s.base ?? s.price ?? 0;
      const extra = s.extra ?? 0;
      return base + extraGuests * extra;
    })
  );
}
